import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMap = () => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [showFullMap, setShowFullMap] = useState(false);

  const location = {
    name: 'Surat, IN',
    address: 'Nana Varachha, Surat, Gujarat, India, 395006',
    // Coordinates: 21.1702° N, 72.8311° E
    lat: 21.230005,
    lng: 72.900902,
    description: 'Located in the heart of Surat, available for local meetings and remote collaboration worldwide.'
  };

  const workingLocations = [
    {
      type: 'Primary Office',
      location: 'Surat, IN',
      availability: 'Mon-Fri, 9AM-6PM IST',
      icon: 'Building'
    },
    {
      type: 'Remote Work',
      location: 'Worldwide',
      availability: '24/7 Collaboration',
      icon: 'Globe'
    },
    {
      type: 'Client Meetings',
      location: 'Surat, IN',
      availability: 'By Appointment',
      icon: 'MapPin'
    }
  ];

  const handleMapLoad = () => {
    setMapLoaded(true);
  };

  const openInMaps = () => {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="bg-surface rounded-lg border border-border overflow-hidden">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-text-primary">Location & Availability</h3>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowFullMap(!showFullMap)}
            iconName={showFullMap ? 'Minimize2' : 'Maximize2'}
            iconPosition="left"
          >
            {showFullMap ? 'Minimize' : 'Expand'}
          </Button>
        </div>

        <div className="space-y-4 mb-6">
          {workingLocations.map((loc, index) => (
            <div key={index} className="flex items-start space-x-3 p-3 bg-muted rounded-lg">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={loc.icon} size={18} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-text-primary">{loc.type}</p>
                <p className="text-sm text-text-secondary">{loc.location}</p>
                <p className="text-xs text-text-secondary mt-1">{loc.availability}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Map Container */}
      <div className={`relative bg-muted transition-all duration-300 ${showFullMap ? 'h-96' : 'h-64'}`}>
        {!mapLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <Icon name="MapPin" size={48} color="var(--color-primary)" className="mx-auto mb-2" />
              <p className="text-text-secondary">Loading map...</p>
            </div>
          </div>
        )}

        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={location.name}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${location.lat},${location.lng}&z=14&output=embed`}
          onLoad={handleMapLoad}
          className="border-0"
        />

        {/* Map Overlay */}
        <div className="absolute top-4 left-4 right-4">
          <div className="bg-surface/95 backdrop-blur-sm rounded-lg border border-border p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h4 className="font-semibold text-primary mb-1">{location.name}</h4>
                <p className="text-sm text-secondary mb-2">{location.address}</p>
                <p className="text-xs text-secondary">{location.description}</p>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={openInMaps}
                iconName="ExternalLink"
                iconPosition="left"
                className="text-secondary"
              >
                Open
              </Button>
            </div>
          </div>
        </div>

        {/* Map Controls */}
        <div className="absolute bottom-4 right-4 flex flex-col space-y-2">
          <Button
            variant="outline"
            size="icon"
            onClick={openInMaps}
            title="Open in Google Maps"
            className="bg-surface/95 backdrop-blur-sm"
          >
            <Icon name="Navigation" size={16} />
          </Button>

          <Button
            variant="outline"
            size="icon"
            onClick={() => window.location.href = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`}
            title="Get Directions"
            className="bg-surface/95 backdrop-blur-sm"
          >
            <Icon name="Route" size={16} />
          </Button>
        </div>
      </div>

      {/* Additional Info */}
      <div className="p-6 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center space-x-3">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <div>
              <p className="text-sm font-medium text-text-primary">Business Hours</p>
              <p className="text-xs text-text-secondary">Monday - Friday, 9:00 AM - 6:00 PM IST</p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <Icon name="Globe" size={16} color="var(--color-primary)" />
            <div>
              <p className="text-sm font-medium text-text-primary">Remote Availability</p>
              <p className="text-xs text-text-secondary">Available for global collaboration</p>
            </div>
          </div>
        </div>

        <div className="mt-4 bg-primary/5 rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5" />
            <p className="text-sm text-text-secondary">
              While based in Surat -India, I work with clients worldwide and am available
              for both in-person meetings in Surat and remote collaboration across time zones.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMap;